import axios from 'axios'

export const priceApi = {

    GetPrice({ skuid } = {}) {
        return axios
            .get('/api/v1/price/getprice?skuid=' + skuid)
            .then((response) => {
                return response.data
            })
    },

}
